module.exports = __webpack_public_path__ + "assets/img/video.669e88d1.png";